import {
  AnyQueryAnalyticsCategoryData,
  AnyQueryAnalyticsHistoryData,
  AnyQueryAnalyticsStsData,
  AnyQueryAnalyticsTapsData,
  AnyQueryApi,
  AnyQueryExecuteData,
  WindowWithAnyQuery,
} from '@analytics/const';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@core/feature';
import { WindowRef } from '@spartacus/core';
import { DebugAnalyticsService } from './debug-analytics.service';

@Injectable({ providedIn: 'root' })
export class AnyQueryAnalyticsService {
  get window(): WindowWithAnyQuery {
    return this.winRef.nativeWindow as WindowWithAnyQuery;
  }

  constructor(
    readonly environmentService: EnvironmentService,
    private debugAnalyticsService: DebugAnalyticsService,
    private winRef: WindowRef,
  ) {}

  onClickSts(data: AnyQueryAnalyticsStsData): void {
    this.write('sendAutocompleteQueryClickEvent', data);
  }

  onClickHistory(data: AnyQueryAnalyticsHistoryData): void {
    this.write('sendAutocompleteHistoryClickEvent', data);
  }

  onClickCategory(data: AnyQueryAnalyticsCategoryData): void {
    this.write('sendAutocompleteCategoryClickEvent', data);
  }

  onClickTap(data: AnyQueryAnalyticsTapsData): void {
    this.write('sendAutocompleteTapClickEvent', data);
  }

  onLoadData(data: AnyQueryExecuteData): void {
    if (this.environmentService.isPlatformServer) {
      return;
    }
    this.window.localStorage.setItem('anyQueryData', JSON.stringify(data));
  }

  onSearchPage({ query, productCodes }: { query: string; productCodes: string[] }): void {
    this.write('sendSearchEvent', { searchTerm: query, pageProducts: productCodes });
  }

  private write<Method extends keyof AnyQueryApi>(method: Method, ...data: Parameters<AnyQueryApi[Method]>): void {
    if (this.environmentService.isPlatformServer) {
      return;
    }
    if (this.debugAnalyticsService.debug) {
      // eslint-disable-next-line no-console
      console.log(`Digi.api.${method}`, data);
    }

    this.window.Digi?.api?.[method]?.apply(this.window.Digi.api, data);
  }
}
